<template>
  <div class="content-padding">
    <v-form>
      <v-card style="padding-bottom:20px">
        <v-toolbar color="primary" dark class="elevation-0">
          <v-progress-linear v-if="loading" v-bind:indeterminate="true"></v-progress-linear>
          <v-toolbar-title>Selecciona una novedad</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon>{{options[option].icon}}</v-icon>
          <span class="hidden-xs-only">{{options[option].title}}</span>
          <v-menu offset-y left>
            <template v-slot:activator="{ on }">
              <v-btn icon :loading="loading" v-on="on">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="item in options" :key="item.key" @click="get(item.key)">
                <v-icon>{{ item.icon }}</v-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
        <router-view></router-view>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import router from "@/router";
import { i18n } from "@/i18n";
export default {
  data() {
    return {
      loading: false,
      items: [],
      companyPortalName: "",
      options: [
        {
          key: 0,
          icon: "timer",
          title: i18n.tc("hour", 2),
          router: "NoveltyHour"
        },
        {
          key: 1,
          icon: "local_atm",
          title: i18n.tc("advance", 2),
          router: "NoveltyAdvance"
        },
        {
          key: 2,
          icon: "iso",
          title: i18n.tc("loan", 2),
          router: "NoveltyLoan"
        },
        {
          key: 3,
          icon: "attach_money",
          title: i18n.tc("income", 2) + " / " + i18n.tc("deduction", 2),
          router: "NoveltyIncomeDeduction"
        },
        {
          key: 4,
          icon: "beach_access",
          title: i18n.tc("holiday", 2),
          router: "NoveltyHoliday"
        },
        {
          key: 5,
          icon: "timer_off",
          title: i18n.t("timeNotWorked"),
          router: "NoveltyTimeNotWorked"
        },
        {
          key: 6,
          icon: "history",
          title: i18n.tc("permit", 2),
          router: "NoveltyPermit"
        },
        {
          key: 7,
          icon: "content_paste",
          title: i18n.tc("socialBenefit", 2),
          router: "NoveltySocialBenefit"
        }
      ],
      option: 0
    };
  },
  methods: {
    get: function(optionKey) {
      this.loading = true;
      this.option = optionKey;
      router.push({
        name: this.options[this.option].router,
      });
      this.loading = false;
    }
  },
  mounted: function() {
    this.get(this.option);
  },
};
</script>

<style>
.center-full {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  width: 100%;
  height: 150px;
}
</style>
